export default `---
slug: newsletter-automation
title: "Newsletter Automation"
year: 2025
category: personal
featured: false
tags: [Python, Email Parsing, TTS, Automation, LLM, Work in Progress]
thumbnail: /images/projects/23_email_parser.jpg
description: "Drowning in 5-6 AI newsletters every morning? Build a Python script to parse, clean and read them aloud while you multitask. (Still refining it.)"
relatedLinks: []
---
![newsletter automation](/images/projects/23_email_parser.jpg)

So I started this project in early 2025 and it's still work in progress. The whole thing began with a pretty relatable problem — I was drowning in AI newsletters.

Picture this: every morning I'd wake up to like 5-6 newsletters in my inbox, all packed with the latest AI updates, tips, breaking news, and whatever the tech world decided was important that day. Don't get me wrong, staying up to speed with AI is crucial *(especially when you're trying not to get left behind in 2025)*, but reading through all of this was becoming a serious time sink.

That's when it hit me — why not automate this whole process? The idea was pretty straightforward: write a Python script to grab emails from my inbox, extract the actual content, clean out all the fluff I don't care about, and then send the cleaned text to a text-to-speech server.

The goal? Turn my daily reading into listening, so I could multitask like a champion *(especially if Topi's dog-sitting is busy).*

I actually implemented the idea and got it working — *"I" is a strong word, should be "vibe"* — and used it for a couple of weeks. I could see the value, but it needs refinement and I haven't had the time yet.

## What I'm Still Working On

**Automation First:** I want to set up a proper cron job to run this automatically. Problem is, I need to get a home server for that *(the server is a "magic tool" for other future quests, so I'll probably get it).*

**Content Enhancement:** Right now I'm just cleaning the text, but I'd love to go further. The plan is to use an LLM API to re-elaborate the content, make it more fluent, and maybe even merge topics when multiple newsletters cover the same AI breakthrough. *"Time is money" said Justin Timberlake.*

**The Image Problem:** This is what's bugging me the most — the whole process loses images completely. And you know how these tech newsletters love their charts, infographics, and visual explanations. I'm still debating whether the information in those images is worth the extra reading time.

It's been a pretty cool project to play around with, honestly. Sure, it's taking me longer than expected *(when doesn't it?)*
`;
